import _ from "lodash";
import { CustomSelectImpl } from "./customSelect";
export class MultiSelect extends CustomSelectImpl {
    constructor(options) {
        super(options);
        this.maxDisplayedItems = options.maxDisplayedItems;
        this.countSelectedText =
            options.countSelectedText && options.countSelectedText.includes("{0}")
                ? options.countSelectedText
                : "{0} selected";
    }
    setSelected(chosenItem) {
        chosenItem.selected = !chosenItem.selected;
        this.getListItems()
            .toArray()
            .forEach((l) => {
            const li = $(l);
            if (li.data("item").value === chosenItem.value) {
                if (li.hasClass("selected")) {
                    li.removeClass("selected").attr("aria-selected", "false");
                }
                else {
                    li.addClass("selected").attr("aria-selected", "true");
                }
            }
        });
    }
    getDisplayText() {
        const selectedItems = this.items.filter((i) => i.selected);
        if (!_.some(selectedItems))
            return this.noneSelectedText;
        if (this.maxDisplayedItems !== undefined &&
            selectedItems.length > this.maxDisplayedItems)
            return this.countSelectedText.replace("{0}", selectedItems.length.toString());
        return selectedItems.map((i) => i.displayName).join(", ");
    }
    shouldHideOnClick(e) {
        return $(e.target).closest(".custom-select-list")[0] !== this.list[0];
    }
    preventKeyboardClosure(e) {
        return (!$(e.target).is("button") ||
            _.some(this.list.find("li.custom-select-highlight")));
    }
    selectNext(key) {
        this.showList();
        this.highlightNext(key);
    }
    selectBySearchKeys() {
        this.showList();
        this.highlightBySearchKeys();
    }
}
